<template>
  <v-list-item class="px-0">
    <v-list-item-avatar>
      <v-icon :color="user.role == 'admin' ? 'primary' : 'grey' ">mdi-account</v-icon>
    </v-list-item-avatar>
    <v-list-item-content>
      <v-list-item-title>{{user.first_name + ' '+user.last_name}}</v-list-item-title>
      <v-list-item-subtitle>{{user.role}}</v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action>
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="primary" icon v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="$emit('show', user.uuid)">
            <v-list-item-title>Information</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
export default {
  props: ["user"]
};
</script>

<style lang="scss" scoped>
</style>